/**
 * The app's two-way (or n-way) segmented pill: List / Schedule on the festival lineup, Sets and the group page;
 * Going / Past on the profile; Public / Private on a group. Pass `options` ({ value, label }) for any other set of choices.
 *
 * One highlight slides under the chosen segment (Sam, 2026-10-21: the Public/Private pill "jitters"). Segments never
 * change size: the active one used to gain a border the others lacked, so the row grew 2 px on every switch.
 */
const MODE_LABELS = { list: 'List', schedule: 'Schedule' };

export default function LineupViewToggle({
  view,
  onChange,
  className = '',
  modes = ['schedule', 'list'], // the Sets page's order, everywhere a lineup toggles (Sam, 2026-10-07)
  options,
  ariaLabel = 'Lineup view',
}) {
  const items = options ?? modes.map((mode) => ({ value: mode, label: MODE_LABELS[mode] ?? mode }));
  const index = items.findIndex((it) => it.value === view);
  return (
    <div
      className={`lineup-view-toggle ${className}`}
      role="tablist"
      aria-label={ariaLabel}
      style={{ '--seg-n': items.length, '--seg-i': Math.max(0, index) }}
    >
      {index >= 0 && <span className="lineup-view-toggle__thumb" aria-hidden="true" />}
      {items.map(({ value, label }) => {
        const selected = view === value;
        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`lineup-view-toggle__btn ${selected ? 'lineup-view-toggle__btn--active' : ''}`}
            onClick={() => {
              if (!selected) onChange(value);
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
